import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbf74246"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "auditlogs-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list" }),
  /*#__PURE__*/_createTextVNode(" Audit logs ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  class: "col-md-1 text-right",
  style: {"padding":"0px"}
}
const _hoisted_10 = { class: "col-md-11 text-left" }
const _hoisted_11 = {
  key: 0,
  class: "font-italic"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

import $ from 'jquery';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import _get from 'lodash/get';
import moment from 'moment-timezone';
import { Auditlog, Auditlogvaluechange, Booking, Inspector } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditlogsModal',
  props: {
  name: String,
  field: String,
},
  setup(__props, { expose: __expose }) {

const props = __props;

const store = useStore();

const booking = computed((): Booking => store.getters['diary/booking']);
const inspectors = computed((): Inspector[] => store.getters['diary/inspectorlist']);

const auditLogsModal = ref(null);

const formatDatetime = (val: string) => {
  return moment(val).format("DD/MM/YY hh:mm a");
};

const getFieldDisplayName = (val: string) => {
  return Booking.getFieldDisplayName(val);
};

const getFormattedFieldValue = (field: string, val: string) => {
  let formattedValue: string = val;
  if (field === "inspector.id" && inspectors.value) {
    const inspector = inspectors.value.find(i => i.id === val);
    if (inspector) formattedValue = inspector.name;
  } else {
    formattedValue = val;
  }
  return formattedValue;
};

const auditlogs = computed(() => {
  let logs: Auditlog[] = booking.value ? [...booking.value.auditlogs] : [];
  if (booking.value && booking.value.subbookings) {
    booking.value.subbookings.forEach((sb: Booking) => {
      if (sb.auditlogs) {
        sb.auditlogs.forEach((l: Auditlog) => {
          let sublog: Auditlog = new Auditlog(l);
          sublog.subtype = sb.subtype;
          logs.push(sublog);
        });
      }
    });
  }

  if (props.field) {
    logs = logs.filter((l: Auditlog) =>
      l.valuechanges.find((v: Auditlogvaluechange) => v.fieldname === props.field)
    );
  }

  logs.sort((l1: Auditlog, l2: Auditlog) => {
    if (moment(l1.datetime).isAfter(moment(l2.datetime))) {
      return 1;
    } else if (moment(l1.datetime).isBefore(moment(l2.datetime))) {
      return -1;
    } else {
      return 0;
    }
  });

  return logs;
});

const show = () => {
  if ($(`#${props.name}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.name + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.name}`).show();
  }
}
const hide = () => {
  if ($(`#${props.name}`).length > 0) {
    $(`#${props.name}` + 'Backdrop').remove();
    $(`#${props.name}`).hide();
  }
};

__expose({ show, hide });

return (_ctx: any,_cache: any) => {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", {
    id: __props.name,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`auditlogs-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auditlogs.value, (auditlog, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: $index,
              class: "row mb-4 ml-4"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_avatar, {
                  name: auditlog.user,
                  size: 25,
                  inline: true
                }, null, 8, ["name"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, _toDisplayString(auditlog.user), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(formatDatetime(auditlog.datetime)), 1),
                (auditlog.subtype)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(auditlog.subtype) + " : Sub-booking audit log ", 1))
                  : _createCommentVNode("", true),
                (auditlog.notes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(auditlog.notes), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auditlog.valuechanges, (valuechange, $vcindex) => {
                  return (_openBlock(), _createElementBlock("div", { key: $vcindex }, [
                    (valuechange.fieldname && valuechange.newvalue)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Changed " + _toDisplayString(getFieldDisplayName(valuechange.fieldname)) + " to " + _toDisplayString(getFormattedFieldValue(
                      valuechange.fieldname,
                      valuechange.newvalue
                    )), 1))
                      : _createCommentVNode("", true),
                    (valuechange.fieldname && !valuechange.newvalue)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Deleted " + _toDisplayString(getFieldDisplayName(valuechange.fieldname)), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})